import styled from "styled-components";

export const BillingProductsContainer = styled.div`
  width: 100%;
  min-height: 480px;
  position: relative;
  margin-left: auto;
  margin-right: auto;
`;
export const BillingProductsContainerContent = styled.div`
  width: 98%;
  height: auto;
  min-height: 120px;
  position: relative;
  margin-left: auto;
  margin-right: auto;
  margin-top: 25px;
  display: flex;
  left: 0px;
  justify-content: space-between;
  align-items: center;
`;
export const BillingProductsContainerContentColumnView = styled.div`
  width: 143px;
`;
export const BillingProductsContainerContentColumnProductInfo = styled.div`
  width: 100%;
  height: 70px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
`;
export const BillingProductsContainerContentColumnViewCel = styled.div`
  width: 99%;
  height: 95px;
  position: relative;
  border: 1px solid rgba(61, 61, 61, 0.131);
  border-radius: 3px;
  background-color: white;
  margin-bottom: 10px;
  display: flex;
  align-items: center;
`;
export const BillingProductsContainerContentColumnViewCelPDF = styled.div`
  width: 100%;
  height: 100%;
  position: relative;
  margin-right: auto;
  margin-left: auto;
  display: flex;
  align-items: center;
  cursor: pointer;
`;
export const BillingProductsContainerContentColumnViewCelPDFContent = styled.div`
  width: 75px;
  height: 75;
  position: relative;
  margin-left: auto;
  margin-right: auto;
  display: flex;
  flex-direction: column;
  cursor: pointer;
  span {
    position: relative;
    margin-right: auto;
    margin-left: auto;
    cursor: pointer;
  }

  p {
    font-size: 16px;
    font-family: "Akrobat";
    color: rgb(61,61,61);
    text-align: center;
    cursor: pointer;
  }
`;
export const BillingProductsContainerContentColumnViewCelDouble = styled(BillingProductsContainerContentColumnViewCel)`
  height: 190px;
  flex-direction: column;
`;
export const BillingProductsContainerContentColumnProduct = styled.div`
  width: 480px;
`;
export const BillingProductsContainerContentColumnProductInfoTitle = styled.div`
  width: 100%;
  height: 20px;
  position: relative;

  p {
    font-size: 16px;
    font-family: "Akrobat";
    color: rgb(61,61,61);
    letter-spacing: 0.03rem;
    float: right;
    strong {
      font-size: 17px;
      font-family: "Akrobat ExtraBold";
      color: #80bd01;
    }
  }
`;
export const BillingProductsContainerContentColumnProductCel = styled.div`
  width: 100%;
  height: 95px;
  position: relative;
  border: 1px solid rgba(61, 61, 61, 0.131);
  border-radius: 3px;
  background-color: white;
  margin-bottom: 10px;
  display: flex;
  align-items: center;
`;
export const BillingProductsContainerContentColumnProductCelProd = styled.div`
  width: 90%;
  height: 90%;
  position: relative;
  margin-left: auto;
  margin-right: auto;
  display: flex;
  justify-content: space-around;
  align-items: center;
`;
export const BillingProductsContainerContentColumnProductCelProdImage = styled.div`
  width: 75px;
  height: 85px;
  display: flex;
  align-items: center;

  img{
      width: 65px;
      border: 0.6px solid rgba(61, 61, 61, 0.131);
      border-radius: 3px;
      position: relative;
      margin-left: auto;
      margin-right: auto;
  }
`;
export const BillingProductsContainerContentColumnProductCelProdDesc = styled.div`
width: 310px;
height: 65px;

h1{
  font-size: 15px;
  font-family: 'Akrobat ExtraBold';
  letter-spacing: 0.03rem;
  color: rgb(61,61,61);
}
p{
  font-size: 14px;
  font-family: 'Akrobat';
  letter-spacing: 0.03rem;
  color: rgb(61,61,61);
  margin-top: 5px;
}
`;
export const BillingProductsContainerContentColumnProductCelDouble = styled(BillingProductsContainerContentColumnProductCel)`
height: 190px;
  flex-direction: column;
`;
export const BillingProductsContainerContentColumnConfig = styled.div`
width: 685px;
`;
export const BillingProductsContainerContentColumnInfoTable = styled.div`
width: 100%;
height: 100%;
display: flex;
align-items: center;

table{
    width: 100%;
    height: 60%;

    thead{
        th{

            font-size: 14px;
            font-family: 'Akrobat';
            color: rgb(61,61,61);

            &:nth-child(1){
                width: 100px;
            }

            &:nth-child(2){
                width: 110px;
            }

            &:nth-child(3){
                width: 100px;
            }

            &:nth-child(4){
                width: 100px;
            }

            &:nth-child(5){
                width: 80px;
            }

            &:nth-child(6){
                width: 100px;
            }
        }
    }
}
`;
export const BillingProductsContainerContentColumnConfigCel = styled.div`
 width: 100%;
  height: 95px;
  position: relative;
  border: 1px solid rgba(61, 61, 61, 0.131);
  border-radius: 3px;
  background-color: white;
  margin-bottom: 10px;
  display: flex;
  align-items: center;
`;
export const BillingProductsContainerContentColumnConfigCelConfig = styled.div`
width: 97%;
height: 50%;
position: relative;
margin-left: auto;
margin-right: auto;

`;
export const BillingProductsContainerContentColumnConfigCelConfigTable = styled.div`
table{
width: 100%;
height: 100%;

tbody{
td{

  text-align: center;
  h1{
      font-size: 24px;
      font-family: 'Akrobat ExtraBold';
      color: #58595b;
      text-align: center;
  }

  p{
      font-size: 24px;
      font-family: 'Akrobat';
      color: #58595b;
      text-align: center;
  }

  .cyan{
      font-size: 24px;
      font-family: 'Akrobat ExtraBold';
      color: #18c3ee;
      text-align: center;
  }

  &:nth-child(1){
      width: 90px;
  }

  &:nth-child(2){
      width: 130px;
  }

  &:nth-child(3){
      width: 100px;
  }

  &:nth-child(4){
      width: 100px;
  }

  &:nth-child(5){
      width: 80px;
  }

  &:nth-child(6){
      width: 100px;
  }
}
}
}
`;
export const BillingProductsContainerContentColumnConfigCelConfigTableControlQuantidade = styled.div`
width: 120px;
  height: 40px;
  border: 0.6px solid rgba(61, 61, 61, 0.131);
  border-radius: 3px;
  position: relative;
  margin-left: auto;
  margin-right: auto;
  display: flex;
  justify-content: center;
  align-items: center;
  
  span{
    margin-bottom:0.8rem;
      width: 12%;
      height: 100%;
      font-size: 30px;
      font-family: 'Akrobat SemiBold';
      color: #ff7e00;
      cursor: pointer;
  }

  input{
      width: 60%;
      height: 80%;
      border: none;
      outline: none;
      font-size: 25px;
      font-family: 'Akrobat ExtraBold';
      color: #ff7e00;
      letter-spacing: 0.03rem;
      text-align: center;
  }
`;
export const BillingProductsContainerContentColumnConfigCelDouble = styled(BillingProductsContainerContentColumnConfigCel)`
height: 190px;
      flex-direction: column;
`;
export const BillingProductsContainerContentColumnConfigCelConfigMargin = styled(BillingProductsContainerContentColumnConfigCelConfig)`
  margin-top: 25px;
`;
